module.exports = __webpack_public_path__ + "@/assets/img/046-girl-24.44a06bc5.svg";